// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/workload_federation/v1/workload_federation.proto" (package "c1.api.workload_federation.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
// =============================================================================
// Provider view message
// =============================================================================

/**
 * WorkloadFederationProvider represents a tenant-level OIDC issuer registration.
 *
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationProvider
 */
export interface WorkloadFederationProvider {
    /**
     * The unique ID of the provider.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The display name of the provider.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * A description of what this provider is for.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * The OIDC issuer URL. Immutable after creation.
     *
     * @generated from protobuf field: string issuer_url = 4
     */
    issuerUrl: string;
    /**
     * Whether the provider is disabled. Disabled providers reject all token exchanges.
     *
     * @generated from protobuf field: bool disabled = 5
     */
    disabled: boolean;
    /**
     * The datetime when the provider was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * The datetime when the provider was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * Well-known provider type. Drives UX (wizard presets, docs, icons).
     * Set at creation time, immutable.
     *
     * @generated from protobuf field: c1.api.workload_federation.v1.WellKnownWorkloadProvider well_known_provider = 8
     */
    wellKnownProvider: WellKnownWorkloadProvider;
}
/**
 * WorkloadFederationProviderRef is a reference to a provider by ID.
 * Used for websocket invalidation.
 *
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationProviderRef
 */
export interface WorkloadFederationProviderRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// =============================================================================
// Trust view message
// =============================================================================

/**
 * WorkloadFederationTrust represents a per-SP trust policy that references
 * a tenant-level provider and defines a CEL condition for claim matching.
 *
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationTrust
 */
export interface WorkloadFederationTrust {
    /**
     * The full client ID of the trust (e.g., "clever-fox-42195@acme.conductorone.com/wfe").
     * Used as the client_id parameter in RFC 8693 token exchange requests.
     *
     * @generated from protobuf field: string client_id = 1
     */
    clientId: string;
    /**
     * The service principal user ID this trust belongs to.
     *
     * @generated from protobuf field: string service_principal_id = 2
     */
    servicePrincipalId: string;
    /**
     * The provider ID this trust references. Immutable after creation.
     *
     * @generated from protobuf field: string provider_id = 3
     */
    providerId: string;
    /**
     * The display name of the trust.
     *
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * A description of what this trust policy matches.
     *
     * @generated from protobuf field: string description = 5
     */
    description: string;
    /**
     * CEL expression evaluated against JWT claims. Must return bool.
     * Example: claims.sub.startsWith("repo:acme/infra:") && claims.environment == "production"
     *
     * @generated from protobuf field: string condition_expression = 6
     */
    conditionExpression: string;
    /**
     * IP allowlist for token exchange requests matching this trust.
     *
     * @generated from protobuf field: repeated string allow_source_cidrs = 7
     */
    allowSourceCidrs: string[];
    /**
     * Scoped role IDs. Effective permissions = min(SP roles, trust.scoped_role_ids).
     *
     * @generated from protobuf field: repeated string scoped_role_ids = 8
     */
    scopedRoleIds: string[];
    /**
     * Whether the trust is disabled.
     *
     * @generated from protobuf field: bool disabled = 9
     */
    disabled: boolean;
    /**
     * The datetime when the trust was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 10
     */
    createdAt?: Timestamp;
    /**
     * The datetime when the trust was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 11
     */
    updatedAt?: Timestamp;
    /**
     * JWT claim names from the subject token to copy into the issued C1 token.
     * Values are placed in the "c1wfc" claim as a map[string]string.
     * Only string-valued claims are copied; non-string claims are silently skipped.
     * Example: ["repository", "repository_owner", "job_workflow_ref"]
     *
     * @generated from protobuf field: repeated string passthrough_claims = 12
     */
    passthroughClaims: string[];
}
/**
 * WorkloadFederationTrustRef is a reference to a trust by its cutename ID.
 * Used for websocket invalidation.
 *
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationTrustRef
 */
export interface WorkloadFederationTrustRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// =============================================================================
// Provider CRUD request/response messages
// =============================================================================

// --- CreateProvider ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateProviderRequest
 */
export interface WorkloadFederationServiceCreateProviderRequest {
    /**
     * The display name for the new provider.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * A description of what this provider is for.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * The OIDC issuer URL. Will be validated via OIDC discovery.
     * Normalized on write: lowercase host, no trailing slash, HTTPS only.
     *
     * @generated from protobuf field: string issuer_url = 3
     */
    issuerUrl: string;
    /**
     * Well-known provider type. Required -- UNSPECIFIED is rejected.
     * When set to a named source, the backend validates issuer_url consistency.
     *
     * @generated from protobuf field: c1.api.workload_federation.v1.WellKnownWorkloadProvider well_known_provider = 4
     */
    wellKnownProvider: WellKnownWorkloadProvider;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateProviderResponse
 */
export interface WorkloadFederationServiceCreateProviderResponse {
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1
     */
    provider?: WorkloadFederationProvider;
}
// --- GetProvider ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetProviderRequest
 */
export interface WorkloadFederationServiceGetProviderRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetProviderResponse
 */
export interface WorkloadFederationServiceGetProviderResponse {
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1
     */
    provider?: WorkloadFederationProvider;
}
// --- UpdateProvider ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateProviderRequest
 */
export interface WorkloadFederationServiceUpdateProviderRequest {
    /**
     * The provider with the fields to be updated. The id field identifies the provider.
     *
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1
     */
    provider?: WorkloadFederationProvider;
    /**
     * A comma-separated list of fields to update. For example: "display_name,description".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateProviderResponse
 */
export interface WorkloadFederationServiceUpdateProviderResponse {
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1
     */
    provider?: WorkloadFederationProvider;
}
// --- DeleteProvider ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteProviderRequest
 */
export interface WorkloadFederationServiceDeleteProviderRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteProviderResponse
 */
export interface WorkloadFederationServiceDeleteProviderResponse {
}
// --- ListProviders ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListProvidersRequest
 */
export interface WorkloadFederationServiceListProvidersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListProvidersResponse
 */
export interface WorkloadFederationServiceListProvidersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.workload_federation.v1.WorkloadFederationProvider list = 1
     */
    list: WorkloadFederationProvider[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// =============================================================================
// Trust CRUD request/response messages
// =============================================================================

// --- CreateTrust ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateTrustRequest
 */
export interface WorkloadFederationServiceCreateTrustRequest {
    /**
     * The service principal ID to create the trust for (from URL path).
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The provider this trust references.
     *
     * @generated from protobuf field: string provider_id = 2
     */
    providerId: string;
    /**
     * The display name for the trust.
     *
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * A description of what this trust policy matches.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * CEL expression evaluated against JWT claims. Must return bool.
     * Compiled and validated before storage.
     *
     * @generated from protobuf field: string condition_expression = 5
     */
    conditionExpression: string;
    /**
     * IP allowlist for token exchange requests matching this trust.
     *
     * @generated from protobuf field: repeated string allow_source_cidrs = 6
     */
    allowSourceCidrs: string[];
    /**
     * Scoped role IDs. Effective permissions = min(SP roles, trust.scoped_role_ids).
     *
     * @generated from protobuf field: repeated string scoped_role_ids = 7
     */
    scopedRoleIds: string[];
    /**
     * JWT claim names from the subject token to copy into the issued C1 token.
     *
     * @generated from protobuf field: repeated string passthrough_claims = 8
     */
    passthroughClaims: string[];
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateTrustResponse
 */
export interface WorkloadFederationServiceCreateTrustResponse {
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationTrust trust = 1
     */
    trust?: WorkloadFederationTrust;
}
// --- GetTrust ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetTrustRequest
 */
export interface WorkloadFederationServiceGetTrustRequest {
    /**
     * The service principal ID (from URL path).
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The trust client ID (cutename portion from URL path).
     *
     * @generated from protobuf field: string client_id = 2
     */
    clientId: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetTrustResponse
 */
export interface WorkloadFederationServiceGetTrustResponse {
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationTrust trust = 1
     */
    trust?: WorkloadFederationTrust;
}
// --- UpdateTrust ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateTrustRequest
 */
export interface WorkloadFederationServiceUpdateTrustRequest {
    /**
     * The service principal ID (from URL path).
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The trust with the fields to be updated. The client_id field identifies the trust.
     *
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationTrust trust = 2
     */
    trust?: WorkloadFederationTrust;
    /**
     * A comma-separated list of fields to update. For example: "display_name,condition_expression".
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 3
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateTrustResponse
 */
export interface WorkloadFederationServiceUpdateTrustResponse {
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.WorkloadFederationTrust trust = 1
     */
    trust?: WorkloadFederationTrust;
}
// --- DeleteTrust ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteTrustRequest
 */
export interface WorkloadFederationServiceDeleteTrustRequest {
    /**
     * The service principal ID (from URL path).
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The trust client ID (cutename portion from URL path).
     *
     * @generated from protobuf field: string client_id = 2
     */
    clientId: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteTrustResponse
 */
export interface WorkloadFederationServiceDeleteTrustResponse {
}
// --- ListTrusts ---

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListTrustsRequest
 */
export interface WorkloadFederationServiceListTrustsRequest {
    /**
     * The service principal ID to list trusts for (from URL path).
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListTrustsResponse
 */
export interface WorkloadFederationServiceListTrustsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.workload_federation.v1.WorkloadFederationTrust list = 1
     */
    list: WorkloadFederationTrust[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// =============================================================================
// TestToken request/response messages
// =============================================================================

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestTokenRequest
 */
export interface WorkloadFederationServiceTestTokenRequest {
    /**
     * The service principal ID (from URL path).
     *
     * @generated from protobuf field: string service_principal_id = 1
     */
    servicePrincipalId: string;
    /**
     * The trust client ID (cutename portion from URL path).
     *
     * @generated from protobuf field: string client_id = 2
     */
    clientId: string;
    /**
     * The raw JWT to validate (the subject_token from a CI job).
     *
     * @generated from protobuf field: string subject_token = 3
     */
    subjectToken: string;
    /**
     * Optional: override source IP for CIDR testing.
     * If empty, uses the request's source IP.
     *
     * @generated from protobuf field: string source_ip = 4
     */
    sourceIp: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestTokenResponse
 */
export interface WorkloadFederationServiceTestTokenResponse {
    /**
     * Overall result: true only if ALL steps passed.
     *
     * @generated from protobuf field: bool overall_result = 1
     */
    overallResult: boolean;
    /**
     * Per-step validation results. Every step is always evaluated
     * (we don't short-circuit) so the user sees all problems at once.
     *
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult jwt_decode = 2
     */
    jwtDecode?: TestTokenStepResult;
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult issuer_match = 3
     */
    issuerMatch?: TestTokenStepResult;
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult signature_validation = 4
     */
    signatureValidation?: TestTokenStepResult;
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult audience_validation = 5
     */
    audienceValidation?: TestTokenStepResult;
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult token_freshness = 6
     */
    tokenFreshness?: TestTokenStepResult;
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult cel_evaluation = 7
     */
    celEvaluation?: TestTokenStepResult;
    /**
     * @generated from protobuf field: c1.api.workload_federation.v1.TestTokenStepResult cidr_check = 8
     */
    cidrCheck?: TestTokenStepResult;
    /**
     * The decoded JWT claims (best-effort, even if signature fails).
     * Returned as JSON string for display.
     *
     * @generated from protobuf field: string decoded_claims_json = 9
     */
    decodedClaimsJson: string;
}
/**
 * TestTokenStepResult represents the result of a single validation step.
 *
 * @generated from protobuf message c1.api.workload_federation.v1.TestTokenStepResult
 */
export interface TestTokenStepResult {
    /**
     * Step name for display (e.g., "JWT decode", "Issuer match").
     *
     * @generated from protobuf field: string step_name = 1
     */
    stepName: string;
    /**
     * Whether this step passed.
     *
     * @generated from protobuf field: bool passed = 2
     */
    passed: boolean;
    /**
     * Whether this step was skipped (e.g., CIDR check when no allowlist configured).
     *
     * @generated from protobuf field: bool skipped = 3
     */
    skipped: boolean;
    /**
     * Human-readable detail message.
     *
     * @generated from protobuf field: string detail = 4
     */
    detail: string;
    /**
     * Expected value (for comparison steps).
     *
     * @generated from protobuf field: string expected = 5
     */
    expected: string;
    /**
     * Actual value from the token.
     *
     * @generated from protobuf field: string actual = 6
     */
    actual: string;
}
// =============================================================================
// TestCEL request/response messages
// =============================================================================

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestCELRequest
 */
export interface WorkloadFederationServiceTestCELRequest {
    /**
     * The CEL expression to evaluate. Must return bool.
     *
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
    /**
     * The claims to evaluate against, as a JSON string.
     * Parsed into map[string]any for CEL evaluation.
     *
     * @generated from protobuf field: string claims_json = 2
     */
    claimsJson: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestCELResponse
 */
export interface WorkloadFederationServiceTestCELResponse {
    /**
     * Whether the expression matched (returned true).
     *
     * @generated from protobuf field: bool matched = 1
     */
    matched: boolean;
    /**
     * Error message if compilation or evaluation failed.
     *
     * @generated from protobuf field: string error = 2
     */
    error: string;
    /**
     * The expression that was evaluated (echo back).
     *
     * @generated from protobuf field: string expression = 3
     */
    expression: string;
}
// =============================================================================
// SearchTrusts request/response messages
// =============================================================================

/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceSearchTrustsRequest
 */
export interface WorkloadFederationServiceSearchTrustsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Optional: filter trusts by provider ID.
     *
     * @generated from protobuf field: string provider_id = 3
     */
    providerId: string;
    /**
     * Optional: filter trusts by service principal ID.
     *
     * @generated from protobuf field: string service_principal_id = 4
     */
    servicePrincipalId: string;
    /**
     * Optional: full-text search on trust display name and description.
     *
     * @generated from protobuf field: string query = 5
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceSearchTrustsResponse
 */
export interface WorkloadFederationServiceSearchTrustsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.workload_federation.v1.WorkloadFederationTrust list = 1
     */
    list: WorkloadFederationTrust[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// =============================================================================
// Well-known provider type enum (API-layer copy of c1.models.iam.v1)
// =============================================================================

/**
 * WellKnownWorkloadProvider identifies a provider as a well-known OIDC workload
 * identity source. The frontend uses this to drive guided setup wizards, CEL
 * templates, documentation links, and provider-specific UI.
 *
 * @generated from protobuf enum c1.api.workload_federation.v1.WellKnownWorkloadProvider
 */
export enum WellKnownWorkloadProvider {
    /**
     * @generated from protobuf enum value: WELL_KNOWN_WORKLOAD_PROVIDER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_WORKLOAD_PROVIDER_CUSTOM = 1;
     */
    CUSTOM = 1,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_WORKLOAD_PROVIDER_GITHUB_ACTIONS = 2;
     */
    GITHUB_ACTIONS = 2,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_WORKLOAD_PROVIDER_GITLAB_CI = 3;
     */
    GITLAB_CI = 3,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_WORKLOAD_PROVIDER_HCP_TERRAFORM = 4;
     */
    HCP_TERRAFORM = 4,
    /**
     * @generated from protobuf enum value: WELL_KNOWN_WORKLOAD_PROVIDER_AWS_IAM_OUTBOUND = 5;
     */
    AWS_IAM_OUTBOUND = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationProvider$Type extends MessageType<WorkloadFederationProvider> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationProvider", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issuer_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "well_known_provider", kind: "enum", T: () => ["c1.api.workload_federation.v1.WellKnownWorkloadProvider", WellKnownWorkloadProvider, "WELL_KNOWN_WORKLOAD_PROVIDER_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationProvider>): WorkloadFederationProvider {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.issuerUrl = "";
        message.disabled = false;
        message.wellKnownProvider = 0;
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationProvider>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationProvider): WorkloadFederationProvider {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string issuer_url */ 4:
                    message.issuerUrl = reader.string();
                    break;
                case /* bool disabled */ 5:
                    message.disabled = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* c1.api.workload_federation.v1.WellKnownWorkloadProvider well_known_provider */ 8:
                    message.wellKnownProvider = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationProvider, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string issuer_url = 4; */
        if (message.issuerUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.issuerUrl);
        /* bool disabled = 5; */
        if (message.disabled !== false)
            writer.tag(5, WireType.Varint).bool(message.disabled);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.WellKnownWorkloadProvider well_known_provider = 8; */
        if (message.wellKnownProvider !== 0)
            writer.tag(8, WireType.Varint).int32(message.wellKnownProvider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationProvider
 */
export const WorkloadFederationProvider = new WorkloadFederationProvider$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationProviderRef$Type extends MessageType<WorkloadFederationProviderRef> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationProviderRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationProviderRef>): WorkloadFederationProviderRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationProviderRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationProviderRef): WorkloadFederationProviderRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationProviderRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationProviderRef
 */
export const WorkloadFederationProviderRef = new WorkloadFederationProviderRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationTrust$Type extends MessageType<WorkloadFederationTrust> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationTrust", [
            { no: 1, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "condition_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "allow_source_cidrs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "scoped_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "passthrough_claims", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationTrust>): WorkloadFederationTrust {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientId = "";
        message.servicePrincipalId = "";
        message.providerId = "";
        message.displayName = "";
        message.description = "";
        message.conditionExpression = "";
        message.allowSourceCidrs = [];
        message.scopedRoleIds = [];
        message.disabled = false;
        message.passthroughClaims = [];
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationTrust>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationTrust): WorkloadFederationTrust {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string client_id */ 1:
                    message.clientId = reader.string();
                    break;
                case /* string service_principal_id */ 2:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string provider_id */ 3:
                    message.providerId = reader.string();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string condition_expression */ 6:
                    message.conditionExpression = reader.string();
                    break;
                case /* repeated string allow_source_cidrs */ 7:
                    message.allowSourceCidrs.push(reader.string());
                    break;
                case /* repeated string scoped_role_ids */ 8:
                    message.scopedRoleIds.push(reader.string());
                    break;
                case /* bool disabled */ 9:
                    message.disabled = reader.bool();
                    break;
                case /* google.protobuf.Timestamp created_at */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* repeated string passthrough_claims */ 12:
                    message.passthroughClaims.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationTrust, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string client_id = 1; */
        if (message.clientId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.clientId);
        /* string service_principal_id = 2; */
        if (message.servicePrincipalId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string provider_id = 3; */
        if (message.providerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.providerId);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string condition_expression = 6; */
        if (message.conditionExpression !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.conditionExpression);
        /* repeated string allow_source_cidrs = 7; */
        for (let i = 0; i < message.allowSourceCidrs.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.allowSourceCidrs[i]);
        /* repeated string scoped_role_ids = 8; */
        for (let i = 0; i < message.scopedRoleIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.scopedRoleIds[i]);
        /* bool disabled = 9; */
        if (message.disabled !== false)
            writer.tag(9, WireType.Varint).bool(message.disabled);
        /* google.protobuf.Timestamp created_at = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated string passthrough_claims = 12; */
        for (let i = 0; i < message.passthroughClaims.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.passthroughClaims[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationTrust
 */
export const WorkloadFederationTrust = new WorkloadFederationTrust$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationTrustRef$Type extends MessageType<WorkloadFederationTrustRef> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationTrustRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationTrustRef>): WorkloadFederationTrustRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationTrustRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationTrustRef): WorkloadFederationTrustRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationTrustRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationTrustRef
 */
export const WorkloadFederationTrustRef = new WorkloadFederationTrustRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceCreateProviderRequest$Type extends MessageType<WorkloadFederationServiceCreateProviderRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceCreateProviderRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 3, name: "issuer_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "2048" } } } },
            { no: 4, name: "well_known_provider", kind: "enum", T: () => ["c1.api.workload_federation.v1.WellKnownWorkloadProvider", WellKnownWorkloadProvider, "WELL_KNOWN_WORKLOAD_PROVIDER_"], options: { "validate.rules": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceCreateProviderRequest>): WorkloadFederationServiceCreateProviderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.issuerUrl = "";
        message.wellKnownProvider = 0;
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceCreateProviderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceCreateProviderRequest): WorkloadFederationServiceCreateProviderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string issuer_url */ 3:
                    message.issuerUrl = reader.string();
                    break;
                case /* c1.api.workload_federation.v1.WellKnownWorkloadProvider well_known_provider */ 4:
                    message.wellKnownProvider = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceCreateProviderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string issuer_url = 3; */
        if (message.issuerUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.issuerUrl);
        /* c1.api.workload_federation.v1.WellKnownWorkloadProvider well_known_provider = 4; */
        if (message.wellKnownProvider !== 0)
            writer.tag(4, WireType.Varint).int32(message.wellKnownProvider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateProviderRequest
 */
export const WorkloadFederationServiceCreateProviderRequest = new WorkloadFederationServiceCreateProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceCreateProviderResponse$Type extends MessageType<WorkloadFederationServiceCreateProviderResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceCreateProviderResponse", [
            { no: 1, name: "provider", kind: "message", T: () => WorkloadFederationProvider }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceCreateProviderResponse>): WorkloadFederationServiceCreateProviderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceCreateProviderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceCreateProviderResponse): WorkloadFederationServiceCreateProviderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationProvider provider */ 1:
                    message.provider = WorkloadFederationProvider.internalBinaryRead(reader, reader.uint32(), options, message.provider);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceCreateProviderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1; */
        if (message.provider)
            WorkloadFederationProvider.internalBinaryWrite(message.provider, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateProviderResponse
 */
export const WorkloadFederationServiceCreateProviderResponse = new WorkloadFederationServiceCreateProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceGetProviderRequest$Type extends MessageType<WorkloadFederationServiceGetProviderRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceGetProviderRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceGetProviderRequest>): WorkloadFederationServiceGetProviderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceGetProviderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceGetProviderRequest): WorkloadFederationServiceGetProviderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceGetProviderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetProviderRequest
 */
export const WorkloadFederationServiceGetProviderRequest = new WorkloadFederationServiceGetProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceGetProviderResponse$Type extends MessageType<WorkloadFederationServiceGetProviderResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceGetProviderResponse", [
            { no: 1, name: "provider", kind: "message", T: () => WorkloadFederationProvider }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceGetProviderResponse>): WorkloadFederationServiceGetProviderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceGetProviderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceGetProviderResponse): WorkloadFederationServiceGetProviderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationProvider provider */ 1:
                    message.provider = WorkloadFederationProvider.internalBinaryRead(reader, reader.uint32(), options, message.provider);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceGetProviderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1; */
        if (message.provider)
            WorkloadFederationProvider.internalBinaryWrite(message.provider, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetProviderResponse
 */
export const WorkloadFederationServiceGetProviderResponse = new WorkloadFederationServiceGetProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceUpdateProviderRequest$Type extends MessageType<WorkloadFederationServiceUpdateProviderRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceUpdateProviderRequest", [
            { no: 1, name: "provider", kind: "message", T: () => WorkloadFederationProvider, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceUpdateProviderRequest>): WorkloadFederationServiceUpdateProviderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceUpdateProviderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceUpdateProviderRequest): WorkloadFederationServiceUpdateProviderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationProvider provider */ 1:
                    message.provider = WorkloadFederationProvider.internalBinaryRead(reader, reader.uint32(), options, message.provider);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceUpdateProviderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1; */
        if (message.provider)
            WorkloadFederationProvider.internalBinaryWrite(message.provider, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateProviderRequest
 */
export const WorkloadFederationServiceUpdateProviderRequest = new WorkloadFederationServiceUpdateProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceUpdateProviderResponse$Type extends MessageType<WorkloadFederationServiceUpdateProviderResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceUpdateProviderResponse", [
            { no: 1, name: "provider", kind: "message", T: () => WorkloadFederationProvider }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceUpdateProviderResponse>): WorkloadFederationServiceUpdateProviderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceUpdateProviderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceUpdateProviderResponse): WorkloadFederationServiceUpdateProviderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationProvider provider */ 1:
                    message.provider = WorkloadFederationProvider.internalBinaryRead(reader, reader.uint32(), options, message.provider);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceUpdateProviderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationProvider provider = 1; */
        if (message.provider)
            WorkloadFederationProvider.internalBinaryWrite(message.provider, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateProviderResponse
 */
export const WorkloadFederationServiceUpdateProviderResponse = new WorkloadFederationServiceUpdateProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceDeleteProviderRequest$Type extends MessageType<WorkloadFederationServiceDeleteProviderRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceDeleteProviderRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceDeleteProviderRequest>): WorkloadFederationServiceDeleteProviderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceDeleteProviderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceDeleteProviderRequest): WorkloadFederationServiceDeleteProviderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceDeleteProviderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteProviderRequest
 */
export const WorkloadFederationServiceDeleteProviderRequest = new WorkloadFederationServiceDeleteProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceDeleteProviderResponse$Type extends MessageType<WorkloadFederationServiceDeleteProviderResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceDeleteProviderResponse", []);
    }
    create(value?: PartialMessage<WorkloadFederationServiceDeleteProviderResponse>): WorkloadFederationServiceDeleteProviderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceDeleteProviderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceDeleteProviderResponse): WorkloadFederationServiceDeleteProviderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceDeleteProviderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteProviderResponse
 */
export const WorkloadFederationServiceDeleteProviderResponse = new WorkloadFederationServiceDeleteProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceListProvidersRequest$Type extends MessageType<WorkloadFederationServiceListProvidersRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceListProvidersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceListProvidersRequest>): WorkloadFederationServiceListProvidersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceListProvidersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceListProvidersRequest): WorkloadFederationServiceListProvidersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceListProvidersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListProvidersRequest
 */
export const WorkloadFederationServiceListProvidersRequest = new WorkloadFederationServiceListProvidersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceListProvidersResponse$Type extends MessageType<WorkloadFederationServiceListProvidersResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceListProvidersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkloadFederationProvider },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceListProvidersResponse>): WorkloadFederationServiceListProvidersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceListProvidersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceListProvidersResponse): WorkloadFederationServiceListProvidersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.workload_federation.v1.WorkloadFederationProvider list */ 1:
                    message.list.push(WorkloadFederationProvider.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceListProvidersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.workload_federation.v1.WorkloadFederationProvider list = 1; */
        for (let i = 0; i < message.list.length; i++)
            WorkloadFederationProvider.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListProvidersResponse
 */
export const WorkloadFederationServiceListProvidersResponse = new WorkloadFederationServiceListProvidersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceCreateTrustRequest$Type extends MessageType<WorkloadFederationServiceCreateTrustRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceCreateTrustRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 5, name: "condition_expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 6, name: "allow_source_cidrs", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}(\\/([0-9]|[1-2][0-9]|3[0-2]))?$" } } } } } },
            { no: 7, name: "scoped_role_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "passthrough_claims", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { minBytes: "1", maxBytes: "256" } } } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceCreateTrustRequest>): WorkloadFederationServiceCreateTrustRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.providerId = "";
        message.displayName = "";
        message.description = "";
        message.conditionExpression = "";
        message.allowSourceCidrs = [];
        message.scopedRoleIds = [];
        message.passthroughClaims = [];
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceCreateTrustRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceCreateTrustRequest): WorkloadFederationServiceCreateTrustRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string provider_id */ 2:
                    message.providerId = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string condition_expression */ 5:
                    message.conditionExpression = reader.string();
                    break;
                case /* repeated string allow_source_cidrs */ 6:
                    message.allowSourceCidrs.push(reader.string());
                    break;
                case /* repeated string scoped_role_ids */ 7:
                    message.scopedRoleIds.push(reader.string());
                    break;
                case /* repeated string passthrough_claims */ 8:
                    message.passthroughClaims.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceCreateTrustRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string provider_id = 2; */
        if (message.providerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.providerId);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string condition_expression = 5; */
        if (message.conditionExpression !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.conditionExpression);
        /* repeated string allow_source_cidrs = 6; */
        for (let i = 0; i < message.allowSourceCidrs.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.allowSourceCidrs[i]);
        /* repeated string scoped_role_ids = 7; */
        for (let i = 0; i < message.scopedRoleIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.scopedRoleIds[i]);
        /* repeated string passthrough_claims = 8; */
        for (let i = 0; i < message.passthroughClaims.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.passthroughClaims[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateTrustRequest
 */
export const WorkloadFederationServiceCreateTrustRequest = new WorkloadFederationServiceCreateTrustRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceCreateTrustResponse$Type extends MessageType<WorkloadFederationServiceCreateTrustResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceCreateTrustResponse", [
            { no: 1, name: "trust", kind: "message", T: () => WorkloadFederationTrust }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceCreateTrustResponse>): WorkloadFederationServiceCreateTrustResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceCreateTrustResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceCreateTrustResponse): WorkloadFederationServiceCreateTrustResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationTrust trust */ 1:
                    message.trust = WorkloadFederationTrust.internalBinaryRead(reader, reader.uint32(), options, message.trust);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceCreateTrustResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationTrust trust = 1; */
        if (message.trust)
            WorkloadFederationTrust.internalBinaryWrite(message.trust, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceCreateTrustResponse
 */
export const WorkloadFederationServiceCreateTrustResponse = new WorkloadFederationServiceCreateTrustResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceGetTrustRequest$Type extends MessageType<WorkloadFederationServiceGetTrustRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceGetTrustRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceGetTrustRequest>): WorkloadFederationServiceGetTrustRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.clientId = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceGetTrustRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceGetTrustRequest): WorkloadFederationServiceGetTrustRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceGetTrustRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string client_id = 2; */
        if (message.clientId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetTrustRequest
 */
export const WorkloadFederationServiceGetTrustRequest = new WorkloadFederationServiceGetTrustRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceGetTrustResponse$Type extends MessageType<WorkloadFederationServiceGetTrustResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceGetTrustResponse", [
            { no: 1, name: "trust", kind: "message", T: () => WorkloadFederationTrust }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceGetTrustResponse>): WorkloadFederationServiceGetTrustResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceGetTrustResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceGetTrustResponse): WorkloadFederationServiceGetTrustResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationTrust trust */ 1:
                    message.trust = WorkloadFederationTrust.internalBinaryRead(reader, reader.uint32(), options, message.trust);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceGetTrustResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationTrust trust = 1; */
        if (message.trust)
            WorkloadFederationTrust.internalBinaryWrite(message.trust, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceGetTrustResponse
 */
export const WorkloadFederationServiceGetTrustResponse = new WorkloadFederationServiceGetTrustResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceUpdateTrustRequest$Type extends MessageType<WorkloadFederationServiceUpdateTrustRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceUpdateTrustRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "trust", kind: "message", T: () => WorkloadFederationTrust, options: { "validate.rules": { message: { skip: true } } } },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceUpdateTrustRequest>): WorkloadFederationServiceUpdateTrustRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceUpdateTrustRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceUpdateTrustRequest): WorkloadFederationServiceUpdateTrustRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* c1.api.workload_federation.v1.WorkloadFederationTrust trust */ 2:
                    message.trust = WorkloadFederationTrust.internalBinaryRead(reader, reader.uint32(), options, message.trust);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceUpdateTrustRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* c1.api.workload_federation.v1.WorkloadFederationTrust trust = 2; */
        if (message.trust)
            WorkloadFederationTrust.internalBinaryWrite(message.trust, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateTrustRequest
 */
export const WorkloadFederationServiceUpdateTrustRequest = new WorkloadFederationServiceUpdateTrustRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceUpdateTrustResponse$Type extends MessageType<WorkloadFederationServiceUpdateTrustResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceUpdateTrustResponse", [
            { no: 1, name: "trust", kind: "message", T: () => WorkloadFederationTrust }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceUpdateTrustResponse>): WorkloadFederationServiceUpdateTrustResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceUpdateTrustResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceUpdateTrustResponse): WorkloadFederationServiceUpdateTrustResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.workload_federation.v1.WorkloadFederationTrust trust */ 1:
                    message.trust = WorkloadFederationTrust.internalBinaryRead(reader, reader.uint32(), options, message.trust);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceUpdateTrustResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.workload_federation.v1.WorkloadFederationTrust trust = 1; */
        if (message.trust)
            WorkloadFederationTrust.internalBinaryWrite(message.trust, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceUpdateTrustResponse
 */
export const WorkloadFederationServiceUpdateTrustResponse = new WorkloadFederationServiceUpdateTrustResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceDeleteTrustRequest$Type extends MessageType<WorkloadFederationServiceDeleteTrustRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceDeleteTrustRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceDeleteTrustRequest>): WorkloadFederationServiceDeleteTrustRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.clientId = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceDeleteTrustRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceDeleteTrustRequest): WorkloadFederationServiceDeleteTrustRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceDeleteTrustRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string client_id = 2; */
        if (message.clientId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteTrustRequest
 */
export const WorkloadFederationServiceDeleteTrustRequest = new WorkloadFederationServiceDeleteTrustRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceDeleteTrustResponse$Type extends MessageType<WorkloadFederationServiceDeleteTrustResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceDeleteTrustResponse", []);
    }
    create(value?: PartialMessage<WorkloadFederationServiceDeleteTrustResponse>): WorkloadFederationServiceDeleteTrustResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceDeleteTrustResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceDeleteTrustResponse): WorkloadFederationServiceDeleteTrustResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceDeleteTrustResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceDeleteTrustResponse
 */
export const WorkloadFederationServiceDeleteTrustResponse = new WorkloadFederationServiceDeleteTrustResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceListTrustsRequest$Type extends MessageType<WorkloadFederationServiceListTrustsRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceListTrustsRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceListTrustsRequest>): WorkloadFederationServiceListTrustsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceListTrustsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceListTrustsRequest): WorkloadFederationServiceListTrustsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceListTrustsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListTrustsRequest
 */
export const WorkloadFederationServiceListTrustsRequest = new WorkloadFederationServiceListTrustsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceListTrustsResponse$Type extends MessageType<WorkloadFederationServiceListTrustsResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceListTrustsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkloadFederationTrust },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceListTrustsResponse>): WorkloadFederationServiceListTrustsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceListTrustsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceListTrustsResponse): WorkloadFederationServiceListTrustsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.workload_federation.v1.WorkloadFederationTrust list */ 1:
                    message.list.push(WorkloadFederationTrust.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceListTrustsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.workload_federation.v1.WorkloadFederationTrust list = 1; */
        for (let i = 0; i < message.list.length; i++)
            WorkloadFederationTrust.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceListTrustsResponse
 */
export const WorkloadFederationServiceListTrustsResponse = new WorkloadFederationServiceListTrustsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceTestTokenRequest$Type extends MessageType<WorkloadFederationServiceTestTokenRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceTestTokenRequest", [
            { no: 1, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z]{3,20}-[a-z]{3,20}-[0-9]{5}$" } } } },
            { no: 3, name: "subject_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "16384" } } } },
            { no: 4, name: "source_ip", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([0-9]{1,3}\\.){3}[0-9]{1,3}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceTestTokenRequest>): WorkloadFederationServiceTestTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.servicePrincipalId = "";
        message.clientId = "";
        message.subjectToken = "";
        message.sourceIp = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceTestTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceTestTokenRequest): WorkloadFederationServiceTestTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string service_principal_id */ 1:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string client_id */ 2:
                    message.clientId = reader.string();
                    break;
                case /* string subject_token */ 3:
                    message.subjectToken = reader.string();
                    break;
                case /* string source_ip */ 4:
                    message.sourceIp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceTestTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string service_principal_id = 1; */
        if (message.servicePrincipalId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string client_id = 2; */
        if (message.clientId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.clientId);
        /* string subject_token = 3; */
        if (message.subjectToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.subjectToken);
        /* string source_ip = 4; */
        if (message.sourceIp !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sourceIp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestTokenRequest
 */
export const WorkloadFederationServiceTestTokenRequest = new WorkloadFederationServiceTestTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceTestTokenResponse$Type extends MessageType<WorkloadFederationServiceTestTokenResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceTestTokenResponse", [
            { no: 1, name: "overall_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "jwt_decode", kind: "message", T: () => TestTokenStepResult },
            { no: 3, name: "issuer_match", kind: "message", T: () => TestTokenStepResult },
            { no: 4, name: "signature_validation", kind: "message", T: () => TestTokenStepResult },
            { no: 5, name: "audience_validation", kind: "message", T: () => TestTokenStepResult },
            { no: 6, name: "token_freshness", kind: "message", T: () => TestTokenStepResult },
            { no: 7, name: "cel_evaluation", kind: "message", T: () => TestTokenStepResult },
            { no: 8, name: "cidr_check", kind: "message", T: () => TestTokenStepResult },
            { no: 9, name: "decoded_claims_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceTestTokenResponse>): WorkloadFederationServiceTestTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.overallResult = false;
        message.decodedClaimsJson = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceTestTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceTestTokenResponse): WorkloadFederationServiceTestTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool overall_result */ 1:
                    message.overallResult = reader.bool();
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult jwt_decode */ 2:
                    message.jwtDecode = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.jwtDecode);
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult issuer_match */ 3:
                    message.issuerMatch = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.issuerMatch);
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult signature_validation */ 4:
                    message.signatureValidation = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.signatureValidation);
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult audience_validation */ 5:
                    message.audienceValidation = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.audienceValidation);
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult token_freshness */ 6:
                    message.tokenFreshness = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.tokenFreshness);
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult cel_evaluation */ 7:
                    message.celEvaluation = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.celEvaluation);
                    break;
                case /* c1.api.workload_federation.v1.TestTokenStepResult cidr_check */ 8:
                    message.cidrCheck = TestTokenStepResult.internalBinaryRead(reader, reader.uint32(), options, message.cidrCheck);
                    break;
                case /* string decoded_claims_json */ 9:
                    message.decodedClaimsJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceTestTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool overall_result = 1; */
        if (message.overallResult !== false)
            writer.tag(1, WireType.Varint).bool(message.overallResult);
        /* c1.api.workload_federation.v1.TestTokenStepResult jwt_decode = 2; */
        if (message.jwtDecode)
            TestTokenStepResult.internalBinaryWrite(message.jwtDecode, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.TestTokenStepResult issuer_match = 3; */
        if (message.issuerMatch)
            TestTokenStepResult.internalBinaryWrite(message.issuerMatch, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.TestTokenStepResult signature_validation = 4; */
        if (message.signatureValidation)
            TestTokenStepResult.internalBinaryWrite(message.signatureValidation, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.TestTokenStepResult audience_validation = 5; */
        if (message.audienceValidation)
            TestTokenStepResult.internalBinaryWrite(message.audienceValidation, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.TestTokenStepResult token_freshness = 6; */
        if (message.tokenFreshness)
            TestTokenStepResult.internalBinaryWrite(message.tokenFreshness, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.TestTokenStepResult cel_evaluation = 7; */
        if (message.celEvaluation)
            TestTokenStepResult.internalBinaryWrite(message.celEvaluation, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.workload_federation.v1.TestTokenStepResult cidr_check = 8; */
        if (message.cidrCheck)
            TestTokenStepResult.internalBinaryWrite(message.cidrCheck, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string decoded_claims_json = 9; */
        if (message.decodedClaimsJson !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.decodedClaimsJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestTokenResponse
 */
export const WorkloadFederationServiceTestTokenResponse = new WorkloadFederationServiceTestTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestTokenStepResult$Type extends MessageType<TestTokenStepResult> {
    constructor() {
        super("c1.api.workload_federation.v1.TestTokenStepResult", [
            { no: 1, name: "step_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "passed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "skipped", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "expected", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "actual", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TestTokenStepResult>): TestTokenStepResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.stepName = "";
        message.passed = false;
        message.skipped = false;
        message.detail = "";
        message.expected = "";
        message.actual = "";
        if (value !== undefined)
            reflectionMergePartial<TestTokenStepResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TestTokenStepResult): TestTokenStepResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string step_name */ 1:
                    message.stepName = reader.string();
                    break;
                case /* bool passed */ 2:
                    message.passed = reader.bool();
                    break;
                case /* bool skipped */ 3:
                    message.skipped = reader.bool();
                    break;
                case /* string detail */ 4:
                    message.detail = reader.string();
                    break;
                case /* string expected */ 5:
                    message.expected = reader.string();
                    break;
                case /* string actual */ 6:
                    message.actual = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TestTokenStepResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string step_name = 1; */
        if (message.stepName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.stepName);
        /* bool passed = 2; */
        if (message.passed !== false)
            writer.tag(2, WireType.Varint).bool(message.passed);
        /* bool skipped = 3; */
        if (message.skipped !== false)
            writer.tag(3, WireType.Varint).bool(message.skipped);
        /* string detail = 4; */
        if (message.detail !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.detail);
        /* string expected = 5; */
        if (message.expected !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.expected);
        /* string actual = 6; */
        if (message.actual !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.actual);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.TestTokenStepResult
 */
export const TestTokenStepResult = new TestTokenStepResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceTestCELRequest$Type extends MessageType<WorkloadFederationServiceTestCELRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceTestCELRequest", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "claims_json", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "2", maxBytes: "65536" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceTestCELRequest>): WorkloadFederationServiceTestCELRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        message.claimsJson = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceTestCELRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceTestCELRequest): WorkloadFederationServiceTestCELRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                case /* string claims_json */ 2:
                    message.claimsJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceTestCELRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        /* string claims_json = 2; */
        if (message.claimsJson !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.claimsJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestCELRequest
 */
export const WorkloadFederationServiceTestCELRequest = new WorkloadFederationServiceTestCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceTestCELResponse$Type extends MessageType<WorkloadFederationServiceTestCELResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceTestCELResponse", [
            { no: 1, name: "matched", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceTestCELResponse>): WorkloadFederationServiceTestCELResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.matched = false;
        message.error = "";
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceTestCELResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceTestCELResponse): WorkloadFederationServiceTestCELResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool matched */ 1:
                    message.matched = reader.bool();
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                case /* string expression */ 3:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceTestCELResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool matched = 1; */
        if (message.matched !== false)
            writer.tag(1, WireType.Varint).bool(message.matched);
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        /* string expression = 3; */
        if (message.expression !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceTestCELResponse
 */
export const WorkloadFederationServiceTestCELResponse = new WorkloadFederationServiceTestCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceSearchTrustsRequest$Type extends MessageType<WorkloadFederationServiceSearchTrustsRequest> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceSearchTrustsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "service_principal_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceSearchTrustsRequest>): WorkloadFederationServiceSearchTrustsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.providerId = "";
        message.servicePrincipalId = "";
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceSearchTrustsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceSearchTrustsRequest): WorkloadFederationServiceSearchTrustsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string provider_id */ 3:
                    message.providerId = reader.string();
                    break;
                case /* string service_principal_id */ 4:
                    message.servicePrincipalId = reader.string();
                    break;
                case /* string query */ 5:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceSearchTrustsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string provider_id = 3; */
        if (message.providerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.providerId);
        /* string service_principal_id = 4; */
        if (message.servicePrincipalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.servicePrincipalId);
        /* string query = 5; */
        if (message.query !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceSearchTrustsRequest
 */
export const WorkloadFederationServiceSearchTrustsRequest = new WorkloadFederationServiceSearchTrustsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkloadFederationServiceSearchTrustsResponse$Type extends MessageType<WorkloadFederationServiceSearchTrustsResponse> {
    constructor() {
        super("c1.api.workload_federation.v1.WorkloadFederationServiceSearchTrustsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WorkloadFederationTrust },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<WorkloadFederationServiceSearchTrustsResponse>): WorkloadFederationServiceSearchTrustsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<WorkloadFederationServiceSearchTrustsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: WorkloadFederationServiceSearchTrustsResponse): WorkloadFederationServiceSearchTrustsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.workload_federation.v1.WorkloadFederationTrust list */ 1:
                    message.list.push(WorkloadFederationTrust.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: WorkloadFederationServiceSearchTrustsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.workload_federation.v1.WorkloadFederationTrust list = 1; */
        for (let i = 0; i < message.list.length; i++)
            WorkloadFederationTrust.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.workload_federation.v1.WorkloadFederationServiceSearchTrustsResponse
 */
export const WorkloadFederationServiceSearchTrustsResponse = new WorkloadFederationServiceSearchTrustsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.workload_federation.v1.WorkloadFederationService
 */
export const WorkloadFederationService = new ServiceType("c1.api.workload_federation.v1.WorkloadFederationService", [
    { name: "CreateProvider", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/workload_federation/providers", group: "Workload Federation" }] }, "authz.method": { role: "OWNER" } }, I: WorkloadFederationServiceCreateProviderRequest, O: WorkloadFederationServiceCreateProviderResponse },
    { name: "GetProvider", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/workload_federation/providers/{id}", group: "Workload Federation" }] }, "authz.method": { role: "OWNER" } }, I: WorkloadFederationServiceGetProviderRequest, O: WorkloadFederationServiceGetProviderResponse },
    { name: "UpdateProvider", options: { "apigw.v1.method": { operations: [{ method: "PATCH", route: "/api/v1/workload_federation/providers/{provider.id}", group: "Workload Federation" }] }, "authz.method": { role: "OWNER" } }, I: WorkloadFederationServiceUpdateProviderRequest, O: WorkloadFederationServiceUpdateProviderResponse },
    { name: "DeleteProvider", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/workload_federation/providers/{id}", group: "Workload Federation" }] }, "authz.method": { role: "OWNER" } }, I: WorkloadFederationServiceDeleteProviderRequest, O: WorkloadFederationServiceDeleteProviderResponse },
    { name: "ListProviders", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/workload_federation/providers", group: "Workload Federation" }] }, "authz.method": { role: "OWNER" } }, I: WorkloadFederationServiceListProvidersRequest, O: WorkloadFederationServiceListProvidersResponse },
    { name: "CreateTrust", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/service_principals/{service_principal_id}/trusts", group: "Workload Federation" }] }, "authz.method": { role: "EDITOR" } }, I: WorkloadFederationServiceCreateTrustRequest, O: WorkloadFederationServiceCreateTrustResponse },
    { name: "GetTrust", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/service_principals/{service_principal_id}/trusts/{client_id}", group: "Workload Federation" }] }, "authz.method": { role: "VIEWER" } }, I: WorkloadFederationServiceGetTrustRequest, O: WorkloadFederationServiceGetTrustResponse },
    { name: "UpdateTrust", options: { "apigw.v1.method": { operations: [{ method: "PATCH", route: "/api/v1/service_principals/{service_principal_id}/trusts/{trust.client_id}", group: "Workload Federation" }] }, "authz.method": { role: "EDITOR" } }, I: WorkloadFederationServiceUpdateTrustRequest, O: WorkloadFederationServiceUpdateTrustResponse },
    { name: "DeleteTrust", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/service_principals/{service_principal_id}/trusts/{client_id}", group: "Workload Federation" }] }, "authz.method": { role: "EDITOR" } }, I: WorkloadFederationServiceDeleteTrustRequest, O: WorkloadFederationServiceDeleteTrustResponse },
    { name: "ListTrusts", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/service_principals/{service_principal_id}/trusts", group: "Workload Federation" }] }, "authz.method": { role: "VIEWER" } }, I: WorkloadFederationServiceListTrustsRequest, O: WorkloadFederationServiceListTrustsResponse },
    { name: "TestToken", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/service_principals/{service_principal_id}/trusts/{client_id}/test", group: "Workload Federation" }] }, "authz.method": { role: "EDITOR" } }, I: WorkloadFederationServiceTestTokenRequest, O: WorkloadFederationServiceTestTokenResponse },
    { name: "TestCEL", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/workload_federation/test-cel", group: "Workload Federation" }] }, "authz.method": { role: "VIEWER" } }, I: WorkloadFederationServiceTestCELRequest, O: WorkloadFederationServiceTestCELResponse },
    { name: "SearchTrusts", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/workload_federation_trusts", group: "Workload Federation" }] }, "authz.method": { role: "OWNER" } }, I: WorkloadFederationServiceSearchTrustsRequest, O: WorkloadFederationServiceSearchTrustsResponse }
]);
